module.exports = __webpack_public_path__ + "img/404.0d608094.jpg";